import { render, staticRenderFns } from "./TerminateModalComponent.vue?vue&type=template&id=07358f60&"
import script from "./TerminateModalComponent.vue?vue&type=script&lang=js&"
export * from "./TerminateModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports